import { Preflight } from './sendPreparation';
import { zh } from '../../utils/zh';

export function PreflightSummary({ data }: { data: Preflight }) {
    const waitingForReview = data.eligibleCount === 0 && data.notApprovedCount > 0;
    const reasons: Array<[string, number]> = [
        ['待确认名单', data.notApprovedCount], ['格式无效', data.invalidCount], ['疑似拼写错误', data.suspiciousCount],
        ['已排除', data.suppressedCount], ['已发送过', data.alreadySentCount], ['重复邮箱', data.duplicateCount],
        ['缺少模板变量', data.missingCustomFieldCount], ['待审核 AI 草稿', data.missingPersonalizationCount],
        ['缺少联系记录', data.missingConsentCount], ['无可用发件账号', data.missingSenderCount],
    ].filter(([, count]) => Number(count) > 0) as Array<[string, number]>;
    return <div className="send-readiness" aria-label="发送准备情况">
        <div className="send-readiness-count"><span>{waitingForReview ? '待确认名单' : data.eligibleCount ? '本次可发送' : '本次暂无可发送联系人'}</span>
            {(waitingForReview || data.eligibleCount > 0) && <strong>{(waitingForReview ? data.notApprovedCount : data.eligibleCount).toLocaleString()} <small>位</small></strong>}
        </div>
        {waitingForReview && <p>联系人已导入，确认名单后即可继续检查发送。</p>}
        {data.capacityShortfall > 0 && <p className="send-readiness-warning">当前额度还差 {data.capacityShortfall.toLocaleString()} 封，请减少本次数量或调整发件账号。</p>}
        {data.eligibleCount > 0 && data.capacityShortfall === 0 && <p>当前发件额度充足。</p>}
        {data.totalCount === 0 && <p>请先导入联系人，或选择已有名单。</p>}
        {data.deferredByLimitCount > 0 && <p>另有 {data.deferredByLimitCount.toLocaleString()} 位留待后续批次。</p>}
        {reasons.length > 0 && <details><summary>查看待处理与跳过原因</summary>
            <ul>{reasons.map(([label, count]) => <li key={label}><span>{label}</span><strong>{count.toLocaleString()}</strong></li>)}</ul>
            {data.issues.slice(0, 30).map((issue, index) => <div className="send-issue" key={`${issue.leadId}-${index}`}>
                <span>{issue.email || '（空白邮箱）'}</span><small>{zh(issue.category)} · {zh(issue.reason)}</small>
            </div>)}
        </details>}
    </div>;
}
